module.exports = __webpack_public_path__ + "img/logo-um-fkbv.e24b2841.png";